
import React, { useState, useEffect } from 'react';
import './index.less';
import Step from '@/components/Step';
import SetpFirst from '@/pages/selfUnlock/stepFirst';
import StepSecond from '@/pages/selfUnlock/stepSecond';
import StepThird from '@/pages/selfUnlock/stepThird';
import Nav from '@/components/Nav';
import { checkWeGameBindDays } from '@/constants/api';
import useSWR from 'swr';
import { useOutletContext } from 'react-router-dom';
import { LoginInfo } from '@/types';
import { useSetAtom } from 'jotai';
import { loginAtom } from '@/utils/atoms';

const STEPS_MAP = [{
  title: '解封信息',
}, {
  title: '身份验证',
}, {
  title: '解封成功',
}];

const SelfClosure = () => {
  const [step, setStep] = useState(0);
  const [uuid, setUuid] = useState('');
  const [msg, setMsg] = useState('');
  const loginInfo: LoginInfo = useOutletContext();
  const setUpdateLogin = useSetAtom(loginAtom);

  useEffect(() => {
    if (!Object.keys(loginInfo).length) {
      setUpdateLogin({isLogin: false, visibleLogin: true});
    }
  }, [loginInfo]);

  const content: Record<number, React.JSX.Element> = {
    0: <SetpFirst setStep={setStep} setUuid={setUuid} />,
    1: <StepSecond setStep={setStep} uuid={uuid} />,
    2: <StepThird />
  };

  const { data } = useSWR(checkWeGameBindDays + '?isUnSelf=true');

  useEffect(() => {
    if (data && data.retCode !== 'SUCCESS') {
      setMsg(data.message);
    }
  }, [data]);


  return (
    <div>
      <Nav activeMenu={'accountManagement'} />
      <div className='wgClosureBody'>
        <div className="wgClosureMain">
          <div className="wgContent">
            <h3 className="wgContentTitle">
              <span>游戏自助解封</span>
            </h3>
            {
              msg.indexOf('您尚未绑定APP或APP绑定未满30天，无法使用自助解封；请耐心等待24小时后自动解除封停') > -1 ? <div className='errorMsg'>{msg}</div> : <>
                <Step current={step} stepsMap={STEPS_MAP} />
                {content[step]}
                <div className="reminder">
                  <div>温馨提示：</div>
                  <p>通过“游戏自助封停”方式封停的账号，可以自助解封；其他方式封停的账号无法自助解封！</p>
                </div>
              </>
            }
          </div>
        </div>
      </div>

    </div>
  );
};

export default SelfClosure;
